const INVALID_REQUEST_ERROR = 'invalid_request';
const OIDC_PRESIGNUP_LOGOUT_ATTEMPTED_KEY = 'oidcPresignupLogoutAttempted';
const OIDC_PRESIGNUP_SSO_RETRY_KEY = 'oidcPresignupSsoRetry';

export const isOidcAccessDeniedError = search => {
  const params = new URLSearchParams(search);
  const error = params.get('error');
  const errorDescription = params.get('error_description');

  return error === INVALID_REQUEST_ERROR && Boolean(errorDescription);
};

export const isOidcPresignupError = search => {
  if (!isOidcAccessDeniedError(search)) return false;

  const errorDescription =
    new URLSearchParams(search).get('error_description') ?? '';

  return errorDescription.toLowerCase().includes('presignup');
};

export const getOidcPresignupErrorMessage = search => {
  if (!isOidcPresignupError(search)) return '';

  const errorDescription =
    new URLSearchParams(search).get('error_description') ?? '';

  if (!errorDescription) return '';

  return decodeURIComponent(errorDescription.replace(/\+/g, ' '));
};

export const getOidcErrorMessage = search => {
  const params = new URLSearchParams(search);
  const errorDescription = params.get('error_description');
  const error = params.get('error');

  if (errorDescription) {
    return decodeURIComponent(errorDescription.replace(/\+/g, ' '));
  }

  return error || '';
};

export const hasOidcPresignupLogoutAttempted = () =>
  sessionStorage.getItem(OIDC_PRESIGNUP_LOGOUT_ATTEMPTED_KEY) === 'true';

export const setOidcPresignupLogoutAttempted = () => {
  sessionStorage.setItem(OIDC_PRESIGNUP_LOGOUT_ATTEMPTED_KEY, 'true');
};

export const clearOidcPresignupLogoutAttempted = () => {
  sessionStorage.removeItem(OIDC_PRESIGNUP_LOGOUT_ATTEMPTED_KEY);
};

export const isOidcPresignupSsoRetryPending = () =>
  sessionStorage.getItem(OIDC_PRESIGNUP_SSO_RETRY_KEY) === 'true';

export const setOidcPresignupSsoRetryPending = () => {
  sessionStorage.setItem(OIDC_PRESIGNUP_SSO_RETRY_KEY, 'true');
};

export const clearOidcPresignupSsoRetryPending = () => {
  sessionStorage.removeItem(OIDC_PRESIGNUP_SSO_RETRY_KEY);
};

export const clearOidcPresignupRecoveryFlags = () => {
  clearOidcPresignupLogoutAttempted();
  clearOidcPresignupSsoRetryPending();
};
